// SocialCheck – Rollen, App-Modi und rollenbasierte Startseiten
export const APP_MODES = {
  super_admin: { key: "control", label: "KEWAG Control OS" },
  kewag_admin: { key: "team", label: "SocialCheck Team" },
  kewag_finanzen: { key: "finance", label: "KEWAG Finanzen" },
  editor: { key: "team", label: "SocialCheck Team" },
  support: { key: "team", label: "SocialCheck Team" },
  reviewer: { key: "cockpit", label: "Kunden-Cockpit" },
  viewer: { key: "cockpit", label: "Kunden-Cockpit" },
};

export function appMode(role) {
  return APP_MODES[role] || APP_MODES.reviewer;
}

export function canEditPhotoJobs(user, kundensicht) {
  return !kundensicht?.read_only && ["super_admin", "kewag_admin", "editor"].includes(user?.global_role);
}

// Rollenbasierte Startseite nach dem Login
export function roleHome(role) {
  if (["super_admin", "kewag_admin"].includes(role)) return "/aufgaben";
  if (role === "recovery_guardian") return "/kontowiederherstellung";
  if (role === "editor") return "/foto-auftraege";
  if (role === "support") return "/support";
  if (role === "kewag_finanzen") return "/finanzen";
  return "/dashboard";
}
